import React from "react";
import T from "prop-types";
import cn from "classnames";

import { PlaceholderText } from "2g-placeholder";

export function FixniNarokyNasledujiciCount({
  title,
  zadane,
  povolene,
  loading
}) {
  return (
    <div
      className={cn("b2b-FixniNarokyNasledujici-count", {
        "is-full": zadane === povolene
      })}
    >
      <div className="b2b-FixniNarokyNasledujici-countTitle">{title}</div>
      <div className="b2b-FixniNarokyNasledujici-countContent">
        {loading ? (
          <PlaceholderText>5 / 5</PlaceholderText>
        ) : (
          <>
            {zadane} / {povolene}
          </>
        )}
      </div>
    </div>
  );
}

FixniNarokyNasledujiciCount.propTypes = {
  title: T.string,
  zadane: T.number,
  povolene: T.number,
  loading: T.bool
};

export default React.memo(FixniNarokyNasledujiciCount);
